export default "__VITE_ASSET__CHVwfOfh__"